import { render, staticRenderFns } from "./PathwayNotes.vue?vue&type=template&id=0c587e45"
import script from "./PathwayNotes.vue?vue&type=script&lang=js"
export * from "./PathwayNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports